/*
 * @providesModule DataDogRUM
 *
 */

import {datadogRum} from '@datadog/browser-rum';
import {useEffect} from 'react';

class DataDogRUM {
  async initializeDataDog(config: any) {
    datadogRum.init(config);
    datadogRum.startSessionReplayRecording();
  }
  startView(_viewName: string) {
    datadogRum.startView(_viewName);
  }
  stopView() {
    // No needed for web as it relies on browser history
  }

  addAction(_actionName: string, _props: any) {
    datadogRum.addAction(_actionName, _props);
  }
}

export function useDatadogView(viewName: string) {
  useEffect(() => {
    if (datadogRum.getInitConfiguration()) {
      console.debug('DD: Send Start: ' + viewName);
      datadogRum.startView(viewName);
    }
    return () => {};
  }, [viewName]);
}

export function setDatadogUser(_userId: number | string) {
  datadogRum.setUser({id: _userId.toString()});
}

export interface ScreenLoadTimeResult {
  markContentLoaded: () => void;
  markTiming: (timingName: string) => void;
  onViewStarted: () => void;
}

const noop = () => {};
const noopResult: ScreenLoadTimeResult = {
  markContentLoaded: noop,
  markTiming: noop,
  onViewStarted: noop,
};

export function useScreenLoadTime(
  _expectedViewName?: string,
  _waitForView?: boolean
): ScreenLoadTimeResult {
  return noopResult;
}

export class ScreenLoadTimeTracker {
  constructor(_expectedViewName?: string, _waitForView?: boolean) {}
  markFirstRender(): void {}
  markContentLoaded(): void {}
  markTiming(_timingName: string): void {}
  onViewStarted(): void {}
}

export enum ErrorSource {
  NETWORK = 'network',
  SOURCE = 'source',
  CONSOLE = 'console',
  LOGGER = 'logger',
  AGENT = 'agent',
  WEBVIEW = 'webview',
}

const dataDogRum = new DataDogRUM();

export default dataDogRum;
